import React from 'react';
import { useSelector } from 'react-redux';
import { getDivestitureDiagnosticResults } from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import Header from '../../DivestitureDiagnosticResults/Category/Header/Header';
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem';
import ReviewResponsesNavItem from '../SurveySidebar/ReviewResponsesNavItem/ReviewResponsesNavItem';
import './ResultsSidebar.scss';

const ResultsSidebar = () => {
  const results = useSelector(getDivestitureDiagnosticResults);
  const overallDealComplexity = results && results.overallDealComplexity;

  return (
    <>
      {results && (
        <div className="results-sidebar-container">
          <div className="results-sidebar-header">Diagnostic Questionnaire</div>
          <SidebarNavItem path={overallDealComplexity.path}>
            <Header category={overallDealComplexity} isTitleBold minified />
          </SidebarNavItem>
          {results.data
            .filter((cat) => cat.parentId === undefined)
            .map((cat) => (
              <SidebarNavItem key={cat.categoryId} path={cat.path}>
                <Header key={cat.title} category={cat} minified />
              </SidebarNavItem>
            ))}
          <div className="review-responses-nav-item">
            <ReviewResponsesNavItem
              content="results"
              navText="Questionnaire Responses"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ResultsSidebar;
